module.exports = __webpack_public_path__ + "img/lockiconactive.feadcf4b.svg";